import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { Eye, EyeOff, LogIn, Wrench } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useForm } from '../hooks/useForm';
import { useToast } from '../components/Toast';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';
const LoginPage = () => {
    const { login, isAuthenticated, isLoading } = useAuth();
    const { error: showError } = useToast();
    const [showPassword, setShowPassword] = useState(false);
    const { values, errors, isSubmitting, handleChange, handleBlur, handleSubmit, getFieldProps } = useForm({
        initialValues: {
            email: '',
            password: ''
        },
        validationRules: {
            email: {
                required: 'Email é obrigatório',
                pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Email inválido'
                }
            },
            password: {
                required: 'Senha é obrigatória',
                minLength: { value: 6, message: 'Senha deve ter pelo menos 6 caracteres' }
            }
        },
        onSubmit: async (formValues) => {
            try {
                await login(formValues);
            }
            catch (err) {
                showError('Erro no login', err.message);
            }
        }
    });
    // Redirecionar se já estiver logado
    if (isAuthenticated) {
        return _jsx(Navigate, { to: "/dashboard", replace: true });
    }
    if (isLoading) {
        return (_jsx("div", { className: "min-h-screen flex items-center justify-center bg-gray-50", children: _jsx("div", { className: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" }) }));
    }
    return (_jsx("div", { className: "min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8", children: _jsxs("div", { className: "max-w-md w-full space-y-8", children: [_jsxs("div", { className: "text-center", children: [_jsx("div", { className: "mx-auto h-16 w-16 flex items-center justify-center bg-primary-600 rounded-full", children: _jsx(Wrench, { className: "h-8 w-8 text-white" }) }), _jsx("h2", { className: "mt-6 text-3xl font-bold text-gray-900", children: "NexaMakers OS" }), _jsx("p", { className: "mt-2 text-sm text-gray-600", children: "Sistema de Gest\u00E3o de Assist\u00EAncias T\u00E9cnicas" })] }), _jsxs("div", { className: "bg-white py-8 px-6 shadow-lg rounded-lg", children: [_jsxs("form", { onSubmit: handleSubmit, className: "space-y-6", children: [_jsx(Input, { label: "Email", type: "email", autoComplete: "email", placeholder: "seu@email.com", required: true, ...getFieldProps('email') }), _jsx("div", { className: "relative", children: _jsx(Input, { label: "Senha", type: showPassword ? 'text' : 'password', autoComplete: "current-password", placeholder: "Sua senha", required: true, rightIcon: _jsx("button", { type: "button", onClick: () => setShowPassword(!showPassword), className: "text-gray-400 hover:text-gray-600 focus:outline-none", children: showPassword ? (_jsx(EyeOff, { className: "h-4 w-4" })) : (_jsx(Eye, { className: "h-4 w-4" })) }), ...getFieldProps('password') }) }), _jsx(Button, { type: "submit", variant: "primary", size: "lg", fullWidth: true, isLoading: isSubmitting, leftIcon: _jsx(LogIn, { className: "h-4 w-4" }), children: "Entrar" })] }), _jsx("div", { className: "mt-6 text-center", children: _jsxs("p", { className: "text-sm text-gray-600", children: ["N\u00E3o tem uma conta?", ' ', _jsx(Link, { to: "/register", className: "font-medium text-primary-600 hover:text-primary-500", children: "Criar conta" })] }) })] }), _jsx("div", { className: "text-center text-sm text-gray-500", children: _jsx("p", { children: "\u00A9 2025 NexaMakers. Todos os direitos reservados." }) })] }) }));
};
export default LoginPage;
